import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { primaryColor } from '../store/slice/ContentSlice.js';
import { emptyQuote } from "../store/slice/quoteSlice.js";
import { Button, Flex, Typography } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import { isMobile } from "react-device-detect";

const { Title, Text } = Typography;

const OrderThankyouPage = () => {
  const primaryColorValue = useSelector(primaryColor);
  const styling = {margin: 0, textAlign: 'center', maxWidth: '80%'};
  useEffect(() => {
    document.documentElement.style.setProperty('--dynamic-color', primaryColorValue);
  }, [primaryColorValue]);
  const [isFetching, setIsFetching] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const navigateHome = () => {
    // dispatch(emptyInitializeQuotes())
    //  dispatch(emptyUserinfoSlice())
    // dispatch(emptySubmitOrder())

    // 👇️ navigate to /
    navigate("/", { replace: true });
  };

  const incomingOrderId = useSelector(
    (store) => store?.submitOrderRecord?.info?.quote?.incoming_order_id
  );

  useEffect(() => {
    setTimeout(function () {
      setIsFetching(false);
    }, 900);
    dispatch(emptyQuote())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Flex
        vertical
        justify="center"
        align="center"
        gap={15}
      >
        <CheckCircleFilled style={{color: 'green', fontSize: 60}}/>
        <Title level={1} style={styling}>
          Thank you for your order!
        </Title>
        <Title level={4} style={styling}>
          Your order has been successfully placed.
        </Title>
        <Text strong>
          Your Order Id: {isFetching ? "Loading.." : incomingOrderId}
        </Text>
        <Button
          type="primary"
          size="large"
          onClick={navigateHome}
          style={{
            width: isMobile ? '90%' : 200,
          }}
        >
          Continue Shopping
        </Button>
      </Flex>
    </>
  );
};

export default OrderThankyouPage;
